import { z } from 'zod';
import { Chips, GameId, StakeTier } from './domain.js';
/** ── Auth ────────────────────────────────────────────────────────────── */
/**
 * Guest sign-up is the default path: no KYC, minimal PII (PRD §11.2, §11.6).
 * `deviceId` is a client-generated opaque id used only for abuse throttling.
 */
export const GuestAuthRequest = z.object({
    deviceId: z.string().min(8).max(128),
    handle: z.string().min(2).max(18).optional(),
});
export const MagicLinkRequest = z.object({ email: z.string().email() });
export const MagicLinkVerify = z.object({ token: z.string().min(10) });
/** ── Responsible play (S15) — ships in v1, PRD §11.3. ─────────────────── */
export const ResponsibleLimits = z.object({
    /** Minutes; 0 = off. Reminder fires at this cadence. */
    sessionReminderMin: z.number().int().min(0).max(480),
    /** Self-set spend cap in PHP, enforced at IAP checkout. 0 = off. */
    dailySpendCapPhp: z.number().int().min(0).max(100_000),
    /** ISO timestamp; while in the future the account cannot sit at a table. */
    coolOffUntil: z.string().nullable(),
    selfExcludedUntil: z.string().nullable(),
    muteTableTalk: z.boolean(),
});
export const LEDGER_KINDS = [
    'starter_rack',
    'daily_baon',
    'hourly_rescue',
    'iap_topup',
    'buyin_escrow',
    'buyin_refund',
    'pot_payout',
    'tong',
    'admin_adjust',
];
export const CreateKuboRequest = z.object({
    game: GameId,
    tier: StakeTier,
    buyIn: Chips,
});
export const JoinKuboRequest = z.object({ code: z.string().length(6) });
/** ── Store ───────────────────────────────────────────────────────────── */
export const PurchaseRequest = z.object({
    productId: z.string(),
    /** Store receipt blob. Server validates; the client never credits itself. PRD §10. */
    receipt: z.string().min(1),
    platform: z.enum(['ios', 'android', 'sandbox']),
});
//# sourceMappingURL=rest.js.map